import { Component, OnDestroy, OnInit } from '@angular/core';
import { _ } from '~app/shared/utils';
import { Subscription, Observable } from 'rxjs';
import { LoadingConfig } from '~app/components/qm-directives/loading.directive';
import { ValmetDnaValue } from '~app/custom/neve/valmet-dna.service';
import { TagMetadata } from './neve-measurements-tag.interface';

interface TableData {
  rows: {
    formattedValue?: string,
    valmetDnaValue?: ValmetDnaValue,
    valmetDnaWrappedTagsResult: TagMetadata
  }[],
  totalValueSum: string
}

@Component({
  selector: 'qm-neve-measurements-table',
  templateUrl: './neve-measurements-table.component.html',
  styleUrls: ['./neve-measurements-table.component.scss']
})
export class NeveMeasurementsTableComponent implements OnInit, OnDestroy {
  public tableData$: Observable<TableData>;
  public loading: boolean;
  public loadingConfig: LoadingConfig = {
    timeout: 15,
    messages: {
      empty: _('Power data is currently not available'),
    }
  };


  private subs: Subscription[] = [];


  constructor() {

  }

  ngOnDestroy(): void {
    for(const sub of this.subs) {
      sub.unsubscribe();
    }
  }

  async ngOnInit() {
    this.loading = true;

    //this.tableData$ = this.fetchTrendResults(valuesSource$, refreshEvents$);
  }


  /**
   * Filters all other result values except the last (newest)
   *
   */
  // FIXME:
  private getLastValueResults(results: any[]) {
    return results.map(result => {
      const noValuesExist = result.trendResult?.Values.length === 0;
      if(noValuesExist) return result;

      // ensure there is always exactly one value for calculations
      const lastValueOnlyResult = Object.assign({}, result);
      const lastTrendValue = result.trendResult.Values[result.trendResult.Values.length - 1];
      lastValueOnlyResult.trendResult.Values = [lastTrendValue];
      return lastValueOnlyResult;
    })
  }

}
